<template>
    <div class="nav-container">
        <div class="left-logo">
            <img :src="logoUrl" alt="">
            <span class="title">华艺元界</span>
        </div>
        <div class="right-menu">
            <ul class="meun-contaienr">
                <li v-for="(item,index) in menuList" @click="handelClick(item, index)" :key="index" :class="{active:index===activeIndex}">{{ item.title }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import bus from '@/components/eventBus'
export default {
    data () {
        return {
            logoUrl: require('@/assets/imgs/logo.png'),
            activeIndex: 0, // 添加这个属性来跟踪当前激活的菜单索引
            menuList: [
                {
                   id: 1,
                   title: '首页',
                   url: ''
                },
                {
                   id: 2,
                   title: '艺术传播',
                   url: ''
                },
                {
                   id: 3,
                   title: '艺术资讯',
                   url: ''
                },
                {
                   id: 4,
                   title: '入驻',
                   url: ''
                },
                {
                   id: 5,
                   title: '线上展馆',
                   url: ''
                },
                {
                   id: 6,
                   title: 'App下载',
                   url: ''
                },
                {
                   id: 7,
                   title: '华艺数资',
                   url: ''
                },
                {
                   id: 8,
                   title: '关于我们',
                   url: ''
                }
            ]
        }
    },
    mounted() {
      // 监听Home.vue发送的更新Nav菜单的事件
      bus.$on('updateNav', (index) => {
        this.activeIndex = index;
      });
    },
    methods: {
        handelClick (item, index) {
            // 更新本地激活索引
            this.activeIndex = index;

            // 发送事件到Home.vue
            if (item.id === 1) {
                bus.$emit('change', 0)
            }
            if (item.id === 2) {
                bus.$emit('change', 1)
            }
            if (item.id === 3) {
                bus.$emit('change', 2)
            }
            if (item.id === 4) {
                bus.$emit('change', 3)
            }
            if (item.id === 5) {
                bus.$emit('change', 4)
            }
            if (item.id === 6) {
                bus.$emit('change', 5)
            }
             if (item.id === 7) {
                bus.$emit('change', 6)
            }
            if (item.id === 8) {
                bus.$emit('change', 7)
            }
        }
    }

}
</script>

<style lang="less" scoped>
.nav-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: inherit;
    height: inherit;

    .left-logo {
        display: flex;

        img {
            width: 35px;
            height: 35px;
            object-fit: contain;
        }

        .title {
            display: block;
            width: auto;
            height: 35px;
            text-indent: 10px;
            font-size: 24px;
            font-weight: 600;
            line-height: 35px;
        }
    }

    .right-menu {
        flex: 1;
        .meun-contaienr {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            li {
                font-size: 16px;
                text-indent: 100px;
                cursor: pointer;
                color: #8c9198;
                &.active {
                    font-weight: 600;
                    color: #FF7A3B;
                }
                &:hover {
                    color: #FF7A3B;
                }
            }
        }

    }
}
</style>